/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Export_Preset_Name_PlaceholderInputs */

const en_video_export_export_preset_name_placeholder = /** @type {(inputs: Video_Export_Export_Preset_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a name for this preset`)
};

const fr_video_export_export_preset_name_placeholder = /** @type {(inputs: Video_Export_Export_Preset_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez un nom pour ce prereglage`)
};

const de_video_export_export_preset_name_placeholder = /** @type {(inputs: Video_Export_Export_Preset_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie einen Namen für diese Voreinstellung ein.`)
};

const it_video_export_export_preset_name_placeholder = /** @type {(inputs: Video_Export_Export_Preset_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci un nome per questo preset`)
};

const ru_video_export_export_preset_name_placeholder = /** @type {(inputs: Video_Export_Export_Preset_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите название для этого пресета.`)
};

const es_video_export_export_preset_name_placeholder = /** @type {(inputs: Video_Export_Export_Preset_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduzca un nombre para este ajuste preestablecido`)
};

const zh_cn2_video_export_export_preset_name_placeholder = /** @type {(inputs: Video_Export_Export_Preset_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请为此预设输入名称`)
};

const ja_video_export_export_preset_name_placeholder = /** @type {(inputs: Video_Export_Export_Preset_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このプリセットの名前を入力してください`)
};

const hi_video_export_export_preset_name_placeholder = /** @type {(inputs: Video_Export_Export_Preset_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस प्रीसेट के लिए एक नाम दर्ज करें`)
};

const pt_pt2_video_export_export_preset_name_placeholder = /** @type {(inputs: Video_Export_Export_Preset_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insira um nome para esta predefinição.`)
};

/**
* | output |
* | --- |
* | "Enter a name for this preset" |
*
* @param {Video_Export_Export_Preset_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_export_preset_name_placeholder = /** @type {((inputs?: Video_Export_Export_Preset_Name_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Export_Preset_Name_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_export_preset_name_placeholder(inputs)
	if (locale === "de") return de_video_export_export_preset_name_placeholder(inputs)
	if (locale === "it") return it_video_export_export_preset_name_placeholder(inputs)
	if (locale === "ru") return ru_video_export_export_preset_name_placeholder(inputs)
	if (locale === "es") return es_video_export_export_preset_name_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_export_preset_name_placeholder(inputs)
	if (locale === "ja") return ja_video_export_export_preset_name_placeholder(inputs)
	if (locale === "hi") return hi_video_export_export_preset_name_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_export_preset_name_placeholder(inputs)
	return en_video_export_export_preset_name_placeholder(inputs)
});